import React from 'react';
import { FC } from 'react';
import s from './assistantPanel.module.scss';
import { useReadableEventRefresher } from '@zdrbm/zdr-react';
import { AssistantHistoryPanel } from './AssistantHistoryPanel';
import { ConversationPanel } from './ConversationPanel';
import { NewConversationPanel } from './NewConversationPanel';
import { useUiManager } from './hooks/useUiManager';
import { PanelTypes } from './uiManager/AssistantUiManager';

export const AssistantPanel: FC = () => {
    const uiManager = useUiManager();
    const [[currentPanel]] = useReadableEventRefresher(uiManager.currentPanel);

    let component = null;

    switch (currentPanel) {
        case PanelTypes.History:
            component = <AssistantHistoryPanel />;
            break;
        case PanelTypes.Conversation:
            component = <ConversationPanel />;
            break;
        case PanelTypes.NewConversation:
            component = <NewConversationPanel />;
            break;
    }

    return (
        <div className={s.container}>
            <div style={{ flex: 1, overflow: 'auto' }}>{component}</div>
        </div>
    );
};
